import { docEntityBaseNew } from "building-types/entities/docEntityBaseNew";
import type { RuleBasedSelector } from "building-types/selectors/ruleBasedSelectorTypes";

export function ruleBasedSelectorNew({
  name = "Selector",
  rules = [],
}: Partial<RuleBasedSelector> = {}): RuleBasedSelector {
  return {
    ...docEntityBaseNew("RULE_BASED_SELECTOR"),
    name,
    rules,
  };
}
